import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface GetClientByIdResponse {
  id: number
  createdAt: number
  updatedAt: number
  user: number
  customerId: string
  creditCardId: string
  trainerId: number
  buildingId: number
  gender: string
  street: string
  apartment: string
  zipCode: string
  phone: number
  birth: number
  newsletter?: boolean
  notification?: boolean
  active?: boolean
  fromFacebook?: boolean
  tag: string
  deleted?: boolean
  emailConfirmed?: boolean
  entrataId: number
  realPageId: number
  realUnitId: number
  yardiId: string
  yardiPropertyId: string
  statusPMS: number
  moveInDate: number
  moveOutDate: number
  pets?: boolean
  parkingSpotInfo: string
  leaseStart: number
  leaseEnd: number
  tags: string[]
  passedKeylessOnboarding?: false
  paid: number
  paidData: {
    paid: number
    quantity: number
    refunded?: boolean
  }
  isKeylessAccessSuspended?: false
  isAppUser: boolean
  lastAppLogin: number | null
}

const getClientById = async ({ id, signal }: { id: string; signal?: AbortSignal }) => {
  const response = await authAPI.get<GetClientByIdResponse>(`/client/${id}`, {
    signal,
  })

  return response.data
}

export const BASE_CLIENT_BY_ID_QUERY_KEY = 'useGetClientById'
export const getClientByIdQueryKey = (id: string) => [BASE_CLIENT_BY_ID_QUERY_KEY, id] as const

export const useGetClientById = (
  id: string,
  options?: Omit<
    UseQueryOptions<
      GetClientByIdResponse,
      Error,
      GetClientByIdResponse,
      ReturnType<typeof getClientByIdQueryKey>
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery<
    GetClientByIdResponse,
    Error,
    GetClientByIdResponse,
    ReturnType<typeof getClientByIdQueryKey>
  >({
    enabled: !!id,
    queryFn: ({ signal }) => getClientById({ id, signal }),
    queryKey: getClientByIdQueryKey(id),
    ...options,
  })
}
